/*
 * @Author: llzq
 * @Date: 2021-10-24 13:32:01
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:48:32
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import {ResourceUtil} from '../../uploadModal/file.type'
import {Icon,Drawer} from 'antd'

// components
import ClazzVideo from './components/clazzVideo'
import ClazzAudio from './components/clazzAudio'
import ClazzDocument from './components/clazzDocument'
import ClazzPictures from './components/clazzPictures'
import ClazzLink from './components/clazzLink'
import ClazzZip from './components/clazzZip'
import LoadingResource from './components/loadingResource'

// model
import ResourceItem from '../models/resourceItem'

// style
import './style.less'

interface iProps {
    resourceDetails: ResourceItem,
    visible: boolean,
    onCancel: () => void,
    reportData?: (resource_id: string, watch_at: number, look_time: number) => void
}
interface iState {
    visible: boolean,
    toggle: boolean
}

export default class resourceView extends Component<iProps, iState> {
    state: iState = {
        visible: true,
        toggle: true
    }
    eventTrackingReport = (resource_id: string, watch_at: number, look_time: number) => {
        this.props.reportData(resource_id, watch_at, look_time)
    }
    getComponent = (resourceDetails: ResourceItem) => {
        if (resourceDetails.resourceType === 'VIDEO') {
            return <ClazzVideo key={resourceDetails.id} eventTrackingReport={this.eventTrackingReport} extraProps={resourceDetails}></ClazzVideo>
        } else if (resourceDetails.resourceType === 'AUDIO') {
            return <ClazzAudio key={resourceDetails.id} eventTrackingReport={this.eventTrackingReport} extraProps={resourceDetails}></ClazzAudio>
        }  else if (resourceDetails.resourceType === 'PICTURE') {
            return <ClazzPictures key={resourceDetails.id}  extraProps={resourceDetails}></ClazzPictures>
        }  else if (resourceDetails.resourceType === 'DOCUMENT') {
            return <ClazzDocument key={resourceDetails.id}  extraProps={resourceDetails}></ClazzDocument>
        }  else if (resourceDetails.resourceType === 'LINK') {
            return <ClazzLink key={resourceDetails.id}  extraProps={resourceDetails}></ClazzLink>
        }  else if (resourceDetails.resourceType === 'ZIP') {
            return <ClazzZip key={resourceDetails.id}  extraProps={resourceDetails}></ClazzZip>
        } else {
            return <LoadingResource></LoadingResource>
        }
    }
    // 切换
    toggleExtra = () => {
        this.setState({toggle: !this.state.toggle})
    }
    render() {
        let { resourceDetails, visible, onCancel} = this.props
        let {toggle} = this.state
        return (
            <Drawer
                placement="left"
                visible={visible}
                maskClosable={false}
                onClose={onCancel}
                className={visible ? 'resourceView' : 'resourceView resourceView_close'}
            >
                <div className="resourceView_header">
                    <div className="resourceView_title">
                        【{ResourceUtil.fileShowMap(resourceDetails?.resourceType)?.name}】
                        {resourceDetails?.title}
                    </div>
                </div>
                <div className="resourceView_content">
                    <div className="resourceView_content_play">
                        {
                            resourceDetails && this.getComponent(resourceDetails)
                        }
                    </div>
                </div>
            </Drawer>
        )
    }
}
